(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => new Intl.NumberFormat('es-CO', {
    style: 'currency', currency: 'COP', maximumFractionDigits: 0
  }).format(Number(cents || 0) / 100);
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);

  function initReveals() {
    const items = $$('[data-reveal]');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach((item) => item.classList.add('is-inview'));
      return;
    }
    document.documentElement.classList.add('js');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    items.forEach((item) => observer.observe(item));
  }

  function initStory() {
    const story = $('[data-story]');
    if (!story) return;
    if (window.matchMedia('(max-width: 859px)').matches) return;
    const image = $('[data-story-image]', story);
    const counter = $('[data-story-counter]', story);
    const steps = $$('[data-story-step]', story);
    const activate = (step) => {
      const index = Number(step.dataset.storyStep || 0);
      steps.forEach((item) => item.classList.toggle('active', item === step));
      if (image && step.dataset.storySrc && image.src !== step.dataset.storySrc) image.src = step.dataset.storySrc;
      if (counter) counter.textContent = `${index + 1} / ${steps.length}`;
    };
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) activate(entry.target); });
    }, { threshold: 0, rootMargin: '-38% 0px -45%' });
    steps.forEach((step) => observer.observe(step));
  }

  const productCatalog = new Map();
  const colorsByProduct = {
    'combo-premium': ['Negro'],
    'combo-esencial': ['Negro', 'Gris'],
    armario: ['Negro'],
    'zapatera-6': ['Negro', 'Gris'],
    'zapatera-9': ['Negro', 'Gris']
  };
  function readCatalog() {
    $$('[data-product-record]').forEach((record) => {
      productCatalog.set(record.dataset.key, {
        key: record.dataset.key,
        title: record.dataset.title,
        image: record.dataset.image,
        price: Number(record.dataset.price || 0),
        variants: $$('[data-variant-record]', record).map((variant) => ({
          id: variant.dataset.id,
          title: variant.dataset.title || 'Única opción',
          price: Number(variant.dataset.price || 0),
          available: variant.dataset.available === 'true'
        }))
      });
    });
  }

  let selectOrderProduct = () => {};
  function initOrderBuilder() {
    const builder = $('[data-order-builder]');
    if (!builder) return;
    const form = $('[data-ajax-product-form]', builder);
    if (!form) return;
    const variantInput = $('[data-order-variant]', form);
    const quantityInput = $('[data-order-quantity]', form);
    const colorOptions = $('[data-color-options]', form);
    const colorPropertyInput = $('[data-order-color-property]', form);
    const total = $('[data-order-total]', form);
    const summaryTotal = $('[data-order-summary-total]', builder);
    const summaryName = $('[data-order-name]', builder);
    const summaryColor = $('[data-order-color]', builder);
    const summaryImage = $('[data-order-image]', builder);
    const stickyName = $('[data-sticky-name]');
    const stickyPrice = $('[data-sticky-price]');
    let selectedKey = $('[data-order-product]:checked', form)?.value || 'combo-premium';
    let selectedVariant = null;
    let selectedColor = '';

    const selectedProduct = () => productCatalog.get(selectedKey);
    const displayTotal = () => {
      const product = selectedProduct();
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const price = selectedVariant?.price || product?.price || 0;
      const value = money(price * quantity);
      if (total) total.textContent = value;
      if (summaryTotal) summaryTotal.textContent = value;
      if (summaryColor) summaryColor.textContent = `${selectedColor || selectedVariant?.title || 'Única opción'} · ${quantity} ${quantity === 1 ? 'unidad' : 'unidades'}`;
      if (stickyPrice) stickyPrice.textContent = value;
    };

    const chooseVariant = (variant, color) => {
      selectedVariant = variant;
      selectedColor = color || variant?.title || '';
      if (variantInput) variantInput.value = variant?.id || '';
      if (colorPropertyInput) colorPropertyInput.value = selectedColor;
      $$('[data-color-variant]', colorOptions || document).forEach((button) => {
        const active = button.dataset.colorName === selectedColor;
        button.classList.toggle('selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      displayTotal();
    };

    const renderVariants = (product) => {
      if (!colorOptions) return;
      colorOptions.innerHTML = '';
      const variants = product?.variants || [];
      const colors = colorsByProduct[product?.key] || [];
      const firstVariant = variants.find((variant) => variant.available) || variants[0] || null;
      colors.forEach((color, index) => {
        const matchingVariant = variants.find((variant) => variant.title.toLowerCase().includes(color.toLowerCase())) || firstVariant;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.colorVariant = matchingVariant?.id || '';
        button.dataset.colorName = color;
        button.className = index === 0 ? 'selected' : '';
        button.setAttribute('aria-pressed', String(index === 0));
        button.innerHTML = `<i class="${color.toLowerCase().includes('gris') ? 'gray' : 'black'}"></i><span>${escapeHTML(color)}</span>`;
        button.addEventListener('click', () => chooseVariant(matchingVariant, color));
        colorOptions.appendChild(button);
      });
      if (!colors.length || !firstVariant) colorOptions.innerHTML = '<p class="variant-unavailable">El color disponible está indicado en la opción elegida.</p>';
      chooseVariant(firstVariant, colors[0] || firstVariant?.title || '');
    };

    selectOrderProduct = (key, scroll = true) => {
      const product = productCatalog.get(key);
      if (!product?.variants?.length) return;
      selectedKey = key;
      $$('[data-order-product]', form).forEach((radio) => {
        radio.checked = radio.value === key;
        radio.closest('label')?.classList.toggle('selected', radio.checked);
      });
      if (summaryName) summaryName.textContent = product.title;
      if (summaryImage) { summaryImage.src = product.image; summaryImage.alt = product.title; }
      if (stickyName) stickyName.textContent = product.title;
      renderVariants(product);
      if (scroll) form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };

    $$('[data-order-product]', form).forEach((radio) => radio.addEventListener('change', () => selectOrderProduct(radio.value, false)));
    $$('[data-quantity-change]', form).forEach((button) => button.addEventListener('click', () => {
      const next = Math.max(1, Math.min(20, Number(quantityInput.value || 1) + Number(button.dataset.quantityChange || 0)));
      quantityInput.value = next;
      displayTotal();
    }));
    quantityInput?.addEventListener('change', () => {
      quantityInput.value = Math.max(1, Math.min(20, Number(quantityInput.value || 1)));
      displayTotal();
    });
    selectOrderProduct(selectedKey, false);
  }

  async function getCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No fue posible cargar el pedido.');
    return response.json();
  }

  const cartShell = () => $('[data-cart-shell]');
  let closeTimer;
  async function refreshCart(open = false) {
    const cart = await getCart();
    renderCart(cart);
    if (open) openCart();
    return cart;
  }

  function renderCart(cart) {
    const shell = cartShell();
    const list = $('[data-cart-items]', shell || document);
    const foot = $('[data-cart-foot]', shell || document);
    const count = (cart.items || []).reduce((sum, item) => sum + item.quantity, 0);
    $$('[data-cart-count]').forEach((node) => { node.textContent = count; });
    if (!list) return;
    if (!cart.item_count) {
      list.innerHTML = '<div class="cart-empty"><p>Tu pedido está vacío.</p></div>';
      foot?.setAttribute('hidden', '');
      return;
    }
    list.innerHTML = cart.items.map((item) => {
      const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=180` : '';
      const image = imageUrl ? `<img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(item.product_title)}">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${escapeHTML(item.variant_title)}</p>` : '';
      return `<article class="cart-item">${image}<div><h3>${escapeHTML(item.product_title)}</h3>${variant}<strong class="cart-item-price">${money(item.final_line_price)}</strong><div class="cart-item-actions"><div class="cart-quantity"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-delta="-1" aria-label="Disminuir">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHTML(item.key)}" data-delta="1" aria-label="Aumentar">+</button></div><button class="cart-remove" type="button" data-cart-remove="${escapeHTML(item.key)}">Eliminar</button></div></div></article>`;
    }).join('');
    foot?.removeAttribute('hidden');
    const total = $('[data-cart-total]', shell);
    if (total) total.textContent = money(cart.total_price);
  }

  function openCart() {
    const shell = cartShell();
    if (!shell) return;
    window.clearTimeout(closeTimer);
    shell.removeAttribute('hidden');
    shell.removeAttribute('data-closing');
    shell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    $('[data-cart-close]', shell)?.focus({ preventScroll: true });
  }

  function closeCart() {
    const shell = cartShell();
    if (!shell || shell.hasAttribute('hidden')) return;
    shell.setAttribute('data-closing', '');
    document.body.classList.remove('cart-open');
    closeTimer = window.setTimeout(() => {
      shell.setAttribute('hidden', '');
      shell.setAttribute('aria-hidden', 'true');
      shell.removeAttribute('data-closing');
    }, reduceMotion ? 0 : 260);
  }

  async function addProduct(form) {
    const payload = new FormData(form);
    payload.delete('order_product');
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.description || 'No fue posible agregar el producto.');
    await refreshCart(true);
  }

  function initProductForms() {
    $$('[data-ajax-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = $('button[type="submit"]', form);
      const original = button?.textContent;
      if (button) { button.disabled = true; button.textContent = 'Agregando…'; }
      try { await addProduct(form); }
      catch (error) { window.alert(error.message); }
      finally { if (button) { button.disabled = false; button.textContent = original; } }
    }));
    $$('[data-native-variant]').forEach((select) => select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const root = select.closest('[data-native-product]');
      const price = $('[data-native-price]', root);
      if (price) price.textContent = money(option.dataset.price);
    }));
  }

  function initCartControls() {
    $$('[data-cart-open]').forEach((button) => button.addEventListener('click', () => refreshCart(true).catch(() => openCart())));
    $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
    $('[data-continue-shopping]')?.addEventListener('click', () => {
      closeCart();
      const orderSection = $('#pedido');
      if (orderSection) {
        window.setTimeout(() => orderSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }), reduceMotion ? 0 : 280);
      } else {
        window.location.assign('/#pedido');
      }
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });
    document.addEventListener('click', async (event) => {
      const change = event.target.closest('[data-cart-change]');
      const remove = event.target.closest('[data-cart-remove]');
      if (!change && !remove) return;
      const trigger = change || remove;
      if (trigger.disabled) return;
      trigger.disabled = true;
      try {
        const current = change ? Number(change.parentElement.querySelector('span')?.textContent || 1) : 0;
        const quantity = remove ? 0 : Math.max(0, current + Number(change.dataset.delta || 0));
        const response = await fetch('/cart/change.js', {
          method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: trigger.dataset.cartChange || trigger.dataset.cartRemove, quantity })
        });
        if (!response.ok) throw new Error('No fue posible actualizar el pedido.');
        renderCart(await response.json());
      } catch (error) {
        window.alert(error.message);
        trigger.disabled = false;
      }
    });
    refreshCart(false).catch(() => {});
  }

  function initNavigation() {
    $$('[data-sticky-add-order]').forEach((button) => button.addEventListener('click', async () => {
      const orderForm = $('#armarios-product-form');
      if (!orderForm) {
        window.location.assign('/#pedido');
        return;
      }
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Agregando…';
      try { await addProduct(orderForm); }
      catch (error) { window.alert(error.message); }
      finally { button.disabled = false; button.textContent = original; }
    }));
    $$('[data-choose-product]').forEach((button) => button.addEventListener('click', () => selectOrderProduct(button.dataset.chooseProduct, true)));
  }

  document.addEventListener('DOMContentLoaded', () => {
    try { localStorage.removeItem('armarios-order-details-v1'); } catch {}
    readCatalog();
    initReveals();
    initStory();
    initOrderBuilder();
    initProductForms();
    initCartControls();
    initNavigation();
  });
})();
